export const DEFAULT_VIEW_ID = "default";
